import alert from './alert'
import constant from './constant'
import date from './date'
import file from './file'
import loading from './loading'
import telefone from './telefone'
import sort from './sort'
import etapasCompraDireta from './etapasCompraDireta'
import exibirFimProposta from './exibirFimProposta'
import prefixSuffixMoney from '@/views/mixins/prefix-suffix-money'
import jsonUtils from './jsonUtils'
import amparoLegalUtils from '@/views/mixins/amparoLegalUtils'
import versionControl from '@/views/mixins/versionControl'
import qtdeCasasDecimais from '@/views/mixins/qtdeCasasDecimais'

export default {
    install(Vue) {
        Vue.mixin(alert)
        Vue.mixin(constant)
        Vue.mixin(date)
        Vue.mixin(file)
        Vue.mixin(loading)
        Vue.mixin(telefone)
        Vue.mixin(sort)
        Vue.mixin(etapasCompraDireta)
        Vue.mixin(exibirFimProposta)
        Vue.mixin(jsonUtils)
        Vue.mixin(prefixSuffixMoney)
        Vue.mixin(amparoLegalUtils)
        Vue.mixin(versionControl)
        Vue.mixin(qtdeCasasDecimais)
    }
}
